<template>
    <div class="QASearchDiv">
        <div class="SearchDiv">
            <label style="margin-left:30px;">{{ i18n.$t('BBSQASearchQuestion') }}:</label>
            <a-input v-model:value="SearchQuestionvalue" style="width: 220px;margin-left:20px;" placeholder="Enter search content" />
            <label style="margin-left:20px;">{{ i18n.$t('BBSQASearchLabel') }}:</label>
            <a-select
                v-model:value="SearchTypevalue"
                show-search
                placeholder="Select a type"
                option-filter-prop="children"
                style="width: 200px;margin-left:20px;"
            >
                <a-select-option v-for="(item,index) in SearchQuestionoption" :key="index" :value="item">
                {{ item }}
                </a-select-option>
            </a-select>
            <a-button type="primary" style="margin-left:20px;" @click="SearchBBSContent()">
                <template #icon><SearchOutlined /></template>{{ i18n.$t('BBSQASearchGo') }}
            </a-button>
        </div>
        <div class="EmptyDiv" v-if="QASearchData.length == 0">
            <img src="@/assets/svg/empty.svg" class="EmptyIcno">
            <p class="EmptyLabel">{{ i18n.$t('BBSQASearchEmpty') }}</p>
        </div>
        <ul>
            <li class="ContentLi" v-for="item in QASearchData" :key="item.id">
                <div class="ContentTitleIfoDiv" @click="OpenUrl(item.id)">
                    <div class="ContentTitleDiv">
                        <p class="ContentTitleLabel"><label style="color: #03a0d6;">[{{ item.tag }}]</label><label v-if="item.errorCode" style="color: #03a0d6;">[{{ item.errorCode }}]</label>  {{ item.title }}</p>
                    </div>
                    <div class="ContentContentDiv">
                        <p class="ContentContentLabel" v-html="item.content"></p>
                    </div>
                    <div class="ContentInfoDiv">
                        <img src="@/assets/svg/icon_author.svg" class="ContentInfoIcnoAuthor">
                        <label class="ContentInfoText">{{ item.owner.username }}</label>
                        <img src="@/assets/svg/icon_huifu.svg" class="ContentInfoIcnoComment">
                        <label class="ContentInfoText">{{ item.ascount }} {{ i18n.$t('BBSQASearchAnswerCount') }}</label>
                        <img src="@/assets/svg/icon_time.svg" class="ContentInfoIcnoTime">
                        <label class="ContentInfoText">{{ item.createTime }}</label>
                    </div>
                </div>
                <hr style="margin-top:24px;height:1px;border: none;border-top:1px solid #D8D8D8;"/>
            </li>
        </ul>
        <a-pagination
            style="margin-left:35px;padding:15px 0px;"
            :current="currentPage"
            :pageSize="pageSize"
            :total="Total"
            @change="changePage"
        />
    </div>
</template>

<script>
import { defineComponent, ref } from "vue";
import { useI18n } from "@/i18nPlugin";
import { SearchBBSData,SearchBBSTagsData } from '../../api/index';
import { useRouter } from 'vue-router';
export default defineComponent({
    setup() {
        const i18n = useI18n();
        const router = useRouter();
        const token = localStorage.getItem("userToken");
        const QASearchData = ref([]);
        const SearchQuestionoption = ref(["jack","Rose","Tom","Jerry"]);
        const SearchQuestionvalue = ref(undefined);
        const SearchTypevalue = ref(undefined);
        const currentPage = ref(1);
        const pageSize = ref(10);
        const Total = ref(11);
        const OpenUrl = (id) => {
            router.push({ path: '/ATS/BBSDetail', query: { id: id }})
        }
        const SearchBBS = (pageSize,currentPage) => {
            SearchBBSData ({
                search: SearchQuestionvalue.value,
                tag: SearchTypevalue.value,
                pageSize: pageSize,
                currentPage: currentPage
            }).then(res => {
                Total.value = res.total;
                QASearchData.value = res.data;
                // console.log(res)
            }).catch(error => {
                console.log(error)
            });
        }
        const SearchBBSTags = () => {
            SearchBBSTagsData ().then(res => {
                SearchQuestionoption.value = res.data;
                // console.log(res.data)
            }).catch(error => {
                console.log(error)
            });
        }
        const changePage = (page, pageSize) => {
            // console.log('page', page);
            currentPage.value = page
            // console.log('pageSize', pageSize);
            SearchBBS(pageSize,page);
        };
        const SearchBBSContent = () => {
            currentPage.value = 1
            SearchBBS(pageSize.value,currentPage.value);
        };

        return {
            i18n,
            token,
            QASearchData,
            SearchQuestionoption,
            SearchQuestionvalue,
            SearchTypevalue,
            currentPage,
            pageSize,
            Total,
            changePage,
            OpenUrl,
            SearchBBSTags,
            SearchBBS,
            SearchBBSContent
        }
    },
    mounted() {
        this.SearchBBS(this.pageSize,this.currentPage);
        this.SearchBBSTags();
    }
});
</script>

<style scoped>
    p,ul {
        margin: 0px;
        padding: 0px;
    }
    .SearchDiv {
        text-align: left;
        padding: 20px 0px 10px 0px;
    }
    .ContentLi {
        padding: 0 30px;
        text-align: left;
        list-style: none;
        margin-top: 1px;
    }
    .ContentLi:hover {
        background-color: #f8f8f8;
    }
    .ContentLi:hover .ContentTitleLabel {
        color:  #03a0d6;
    }
    .ContentTitleIfoDiv {
        cursor: pointer;
        width: 100%;
        text-align: top;
        display: inline-block;
    }
    .ContentTitleDiv {        
        cursor: pointer;
        margin-top: 25px;
        font-size: 20px;
        color: #353535;
    }
    .ContentTitleLabel {
        cursor: pointer;
        overflow: hidden;
        /* display: -webkit-inline-box;
        width: 420px; */
        color: #000000;
        /* -webkit-line-clamp: 1;
        -webkit-box-orient: vertical; */
    }
    .ContentAuthorDiv {
        margin-top: 11px;
    }
    .ContentAuthorLabel {
        font-size: 16px;
        color: rgba(53,53,53,0.80);
        letter-spacing: 0;
        line-height: 22px;
    }
    .ContentContentDiv {
        width: 680px;
        text-align: left;
        margin-top: 8px;
        display: inline-block;
    }
    .ContentContentLabel {
        font-size: 14px;
        color: rgba(53,53,53,0.80);
        letter-spacing: 0;
        line-height: 22px;
        overflow: hidden;
        display: -webkit-inline-box;
        width: 680px;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
    }
    .ContentInfoDiv {
        margin-top: 17px;
        font-size: 12px;
        color: #BBBBBB;
    }
    .ContentInfoIcnoComment {
        width: 11px;
        height: 12px;
        margin-left: 14px;
        margin-right: 7px;
        display: inline-block;
    }
    .ContentInfoIcnoTime {
        width: 12px;
        height: 12px;
        margin: 0 8px;
        display: inline-block;
    }
    .ContentInfoIcnoAuthor {
        width: 13.8px;
        height: 12px;
        margin-right: 6.2px;
        display: inline-block;
    }
    .ContentInfoText {
        font-size: 12px;
        line-height: 12px;
        color: #BBBBBB;
    }
    .LoadingDiv {
        cursor: pointer;
        width: 680px;
        height: 40px;
        text-align: center;
        margin: 10px 30px;
        background: #F5F5F5;
        border: 1px solid #D7D7D7;
    }
    .LoadingLabel {
        cursor: pointer;
        font-size: 14px;
        line-height: 40px;
        color: #606266;
    }
    .EmptyDiv {
        text-align: center;
        padding: 100px 0;
    }
    .EmptyIcno {
        width: 200px;
        height: 66px;
    }
    .EmptyLabel {
        font-size: 14px;
        color: #BBBBBB;
    }
</style>